/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
//   import config from "../config/createShelf.config.json";
import axios from "axios";
import { LoggerModule } from "@vlinder-web/logger-module-react";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { CREATE_SHELF } from "../graphql";
import { VApplication } from "../../../application";
import moment from "moment-timezone";
import { StorageModule } from "@vlinder-web/storage-module-react";

const log: any = LoggerModule?.getInstance();
const storageService = StorageModule.getInstance();

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface ICreateShelfMethods extends IPluginMethodMap {
  createShelf(args: any): Promise<any>;
}

export class CreateShelfService implements IAgentPlugin {
  readonly methods: ICreateShelfMethods;

  constructor() {
    this.methods = {
      createShelf: this.createShelf.bind(this),
    };
  }

  async createShelf(args: any) {
    log.blue(`createShelf server component:`, args);
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      // return {...config}
      if (client) {
        const res = await client.mutate({
          mutation: CREATE_SHELF,
          variables: {
            data: {
              ...args?.payload,
              activeStatus: "Active",
              band:
                storageService.get("bandConfig", "local")?.band?.appCardId ??
                null,
            },
          },
          fetchPolicy: "no-cache",
        });
        if (res?.data) {
          return {
            ...res?.data?.createShelf,
          };
        }
      }
    } catch (err: any) {
      console.log(`error in table data`, err);
      // return {
      //   isEmpty: true,
      // };
    }
  }
}
